'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinimumNoticeTimeBusyDays = exports.getConfiguredAvailabilityByDate = exports.getConfiguredBookableDates = exports.troubleshotStartTimesForSelectedDate = exports.getGroupedTroubleshotStartTimes = exports.getTroubleshotStartTimes = exports.getBufferTimeRangesWithDescriptions = exports.getStandardLengthBusyTimeRangesWithDescriptions = exports.getDayLongBusyTimeRangesWithDescriptions = exports.getBusyTimeRangesWithDescriptions = exports.getPastTroubleshotStartTimes = exports.getFuturePossibleStartTimes = exports.getConfiguredPossibleStartTimes = exports.getConfiguredAvailableTimeRanges = exports.isTroubleshootingSelector = exports.canTroubleshootSelector = exports.userLoggedInToValidPortal = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _Immutable = require('Immutable');

var _analytics = require('MeetingsLib/utils/analytics');

var _GateSelectors = require('MeetingsLib/selectors/GateSelectors');

var _utils = require('MeetingsBase/utils/utils');

var _utils2 = require('MeetingsLib/utils/utils');

var _troubleshootStartTimes = require('MeetingsLib/utils/troubleshootStartTimes');

var _TimeRangeListUtils = require('MeetingsBase/utils/TimeRangeListUtils');

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _RESTParamSelectors = require('MeetingsLib/selectors/RESTParamSelectors');

var _enums = require('MeetingsLib/constants/enums');

var _dates = require('MeetingsBase/constants/dates');

var _AvailabilityMilliseconds = require('MeetingsBase/models/AvailabilityMilliseconds');

var _AvailabilityMilliseconds2 = _interopRequireDefault(_AvailabilityMilliseconds);

var _TimeRangeWithDescription = require('MeetingsLib/models/TimeRangeWithDescription');

var _TimeRangeWithDescription2 = _interopRequireDefault(_TimeRangeWithDescription);

var _TimeRange = require('MeetingsBase/models/TimeRange');

var _TimeRange2 = _interopRequireDefault(_TimeRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _Immutable.is);

var isTroubleshooting = (0, _get2.default)('troubleshooting');

var userLoggedInToValidPortal = exports.userLoggedInToValidPortal = function userLoggedInToValidPortal(state) {
  var portalIdFromUserProfile = (0, _get2.default)('portalId', state);
  var portalIdFromLoginCookie = (0, _analytics.getHubSpotHubId)();
  return portalIdFromUserProfile && portalIdFromLoginCookie && '' + portalIdFromUserProfile === portalIdFromLoginCookie;
};

var canTroubleshootSelector = exports.canTroubleshootSelector = createSelector([_GateSelectors.isUngatedForTroubleshooting, _RESTParamSelectors.getEmbedded, _BookInfoSelectors.getOffline, userLoggedInToValidPortal], function (ungatedForTroubleshooting, embedded, offline, loggedIn) {
  return ungatedForTroubleshooting && !embedded && !offline && loggedIn || false;
});

var isTroubleshootingSelector = exports.isTroubleshootingSelector = createSelector([isTroubleshooting, canTroubleshootSelector], function (troubleshooting, canTroubleshoot) {
  return troubleshooting && canTroubleshoot;
});

var getConfiguredAvailableTimeRanges = exports.getConfiguredAvailableTimeRanges = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getCustomParams], function (troubleshooting, customParams) {
  if (!troubleshooting) {
    return (0, _Immutable.List)();
  }

  return (0, _utils.getConfiguredAvailableTimeRanges)(_AvailabilityMilliseconds2.default.fromAvailability(customParams.availability), customParams.weeksToAdvertise, customParams.customAvailabilityStartDate, customParams.customAvailabilityEndDate, customParams.timezone, (0, _utils2.getTimeAtLoad)());
});

var getConfiguredPossibleStartTimes = exports.getConfiguredPossibleStartTimes = createSelector([_GateSelectors.isUngatedForFifteenMinuteStartTimes, getConfiguredAvailableTimeRanges, _BookInfoSelectors.getEvent], function (ungatedForFifteenMinuteStartTimes, configuredAvailableTimeRanges, event) {
  var calculateStartTimes = ungatedForFifteenMinuteStartTimes ? _TimeRangeListUtils.getFifteenMinuteStartTimes : _TimeRangeListUtils.getMeetingLengthStartTimes;

  return calculateStartTimes(configuredAvailableTimeRanges, event.duration);
});

var getFuturePossibleStartTimes = exports.getFuturePossibleStartTimes = createSelector(getConfiguredPossibleStartTimes, function (allPossibleStartTimes) {
  var now = (0, _utils2.getTimeAtLoad)();
  return allPossibleStartTimes.filter(function (time) {
    return time >= now;
  });
});

var getPastTroubleshotStartTimes = exports.getPastTroubleshotStartTimes = createSelector(getConfiguredPossibleStartTimes, function (allPossibleStartTimes) {
  var now = (0, _utils2.getTimeAtLoad)();
  return (0, _troubleshootStartTimes.troubleshootPastStartTimes)(allPossibleStartTimes, now);
});

/**
 * @param {boolean} isTroubleshootingSelector Whether user is troubleshooting
 * @param {BookInfo} bookInfo Busy times data
 * @returns {List} All users' busy time ranges, with descriptions including
 * which user they belong to, and whether they're all-day or standard length
 * Note: if user is not troubleshooting, don't calculate anything
 */
var getBusyTimeRangesWithDescriptions = exports.getBusyTimeRangesWithDescriptions = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getBookInfo], function (troubleshooting, bookInfo) {
  if (!troubleshooting) {
    return (0, _Immutable.List)();
  }

  var allUsersAndBusyTimes = bookInfo.allUsersBusyTimes;

  return allUsersAndBusyTimes.map(function (userAndBusyTimes) {
    return userAndBusyTimes.busyTimes.map(function (busyTimeRange) {
      var isDayLong = busyTimeRange.duration() >= _dates.ONE_DAY;
      return new _TimeRangeWithDescription2.default({
        timeRange: _TimeRange2.default.from(busyTimeRange),
        ownerFirstName: userAndBusyTimes.firstName,
        ownerLastName: userAndBusyTimes.lastName,
        ownerEmail: userAndBusyTimes.email,
        type: isDayLong ? _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT : _enums.UNAVAILABLE_REASONS.EVENT
      });
    });
  }).flatten(true);
});

// filters events longer than a day
var getDayLongBusyTimeRangesWithDescriptions = exports.getDayLongBusyTimeRangesWithDescriptions = createSelector([getBusyTimeRangesWithDescriptions], function (busyTimeRangesWithDescriptions) {
  return busyTimeRangesWithDescriptions.filter(function (rangeWithDescriptions) {
    return rangeWithDescriptions.type === _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT;
  });
});

// filters events shorter than a day
var getStandardLengthBusyTimeRangesWithDescriptions = exports.getStandardLengthBusyTimeRangesWithDescriptions = createSelector([getBusyTimeRangesWithDescriptions], function (busyTimeRangesWithDescriptions) {
  return busyTimeRangesWithDescriptions.filter(function (rangeWithDescriptions) {
    return rangeWithDescriptions.type === _enums.UNAVAILABLE_REASONS.EVENT;
  });
});

/**
 * @param {boolean} isTroubleshootingSelector Whether user can troubleshoot
 * @param {BookInfo} bookInfo Busy times data
 * @returns {List} Buffer time ranges around all users' calendar events, with
 * descriptions including which user they belong to, and the timestamp of the
 * event they are buffering
 * Note: if user is not troubleshooting, don't calculate anything
 */
var getBufferTimeRangesWithDescriptions = exports.getBufferTimeRangesWithDescriptions = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getBookInfo], function (troubleshooting, bookInfo) {
  if (!troubleshooting) {
    return (0, _Immutable.List)();
  }

  var allUsersAndBusyTimes = bookInfo.allUsersBusyTimes,
      bufferTime = bookInfo.customParams.meetingBufferTime;


  return allUsersAndBusyTimes.map(function (userAndBusyTimes) {
    return userAndBusyTimes.busyTimes.map(function (busyTimeRange) {
      // turn each busy time range into 2 buffer time ranges, one before, one after
      var bufferTimeRanges = (0, _TimeRangeListUtils.getBufferTimeRanges)(busyTimeRange, bufferTime);
      return bufferTimeRanges.map(function (bufferTimeRange) {
        return new _TimeRangeWithDescription2.default({
          relatedEventStartTime: busyTimeRange.start,
          timeRange: _TimeRange2.default.from(bufferTimeRange),
          ownerFirstName: userAndBusyTimes.firstName,
          ownerLastName: userAndBusyTimes.lastName,
          ownerEmail: userAndBusyTimes.email,
          type: _enums.UNAVAILABLE_REASONS.BUFFER
        });
      });
    });
  }).flatten(2);
});

var getTroubleshotStartTimes = exports.getTroubleshotStartTimes = createSelector([isTroubleshootingSelector, getFuturePossibleStartTimes, getPastTroubleshotStartTimes, _BookInfoSelectors.getAvailableStartTimes, _BookInfoSelectors.getCustomParams, _BookInfoSelectors.getMeetingLength, getDayLongBusyTimeRangesWithDescriptions, getStandardLengthBusyTimeRangesWithDescriptions, getBufferTimeRangesWithDescriptions], function (troubleshooting, futurePossibleStartTimes, troubleshotPastStartTimes, availableStartTimes, customParams, duration, dayLongBusyTimeRangesWithDescriptions, standardBusyTimeRangesWithDescriptions, bufferTimeRangesWithDescriptions) {
  if (!troubleshooting) {
    return (0, _Immutable.List)();
  }

  var minimumNoticeTime = customParams.minimumNoticeTime;

  var now = (0, _utils2.getTimeAtLoad)();

  var troubleshotStartTimes = (0, _troubleshootStartTimes.troubleshootAvailableTimes)(futurePossibleStartTimes, availableStartTimes);
  var troubleshoot = (0, _pipe2.default)((0, _troubleshootStartTimes.troubleshootMinimumNoticeTime)(minimumNoticeTime, now), (0, _troubleshootStartTimes.troubleshootTimeRanges)(duration, dayLongBusyTimeRangesWithDescriptions), (0, _troubleshootStartTimes.troubleshootTimeRanges)(duration, standardBusyTimeRangesWithDescriptions), (0, _troubleshootStartTimes.troubleshootTimeRanges)(duration, bufferTimeRangesWithDescriptions), _troubleshootStartTimes.removeTimesWithoutReasons);
  troubleshotStartTimes = troubleshoot(troubleshotStartTimes);

  return troubleshotPastStartTimes.concat(troubleshotStartTimes).sort(function (timeA, timeB) {
    return timeA.time - timeB.time;
  });
});

var getGroupedTroubleshotStartTimes = exports.getGroupedTroubleshotStartTimes = createSelector([getTroubleshotStartTimes, _BookInfoSelectors.getUserTimezone], function (troubleshotStartTimes, userTimezone) {
  return troubleshotStartTimes.groupBy(function (troubleshotTime) {
    return _I18n2.default.moment(troubleshotTime.time).tz(userTimezone).format('YYYY-MM-DD');
  });
});

// Date selectors

var troubleshotStartTimesForSelectedDate = exports.troubleshotStartTimesForSelectedDate = createSelector([getGroupedTroubleshotStartTimes, _BookInfoSelectors.getEvent], function (groupedTroubleshotStartTimes, event) {
  return groupedTroubleshotStartTimes.get(event.dateString) || (0, _Immutable.List)();
});

var getConfiguredBookableDates = exports.getConfiguredBookableDates = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getCustomParams], function (troubleshooting, customParams) {
  if (!troubleshooting) {
    return (0, _Immutable.List)();
  }

  var weeksToAdvertise = customParams.weeksToAdvertise,
      customAvailabilityStartDate = customParams.customAvailabilityStartDate,
      customAvailabilityEndDate = customParams.customAvailabilityEndDate;

  var now = (0, _utils2.getTimeAtLoad)();
  return (0, _utils.getBookableDays)(weeksToAdvertise, customAvailabilityStartDate, customAvailabilityEndDate, now).map(function (startDayTimestamp) {
    return _I18n2.default.moment.utc(startDayTimestamp).format('YYYY-MM-DD');
  });
});

var getConfiguredAvailabilityByDate = exports.getConfiguredAvailabilityByDate = createSelector([getConfiguredPossibleStartTimes, _BookInfoSelectors.getUserTimezone], function (configuredPossibleStartTimes, userTimezone) {
  return configuredPossibleStartTimes.groupBy(function (startTime) {
    return _I18n2.default.moment(startTime).tz(userTimezone).format('YYYY-MM-DD');
  });
});

var getMinimumNoticeTimeBusyDays = exports.getMinimumNoticeTimeBusyDays = createSelector([_BookInfoSelectors.getCustomParams], function (customParams) {
  var minimumNoticeTime = customParams.minimumNoticeTime;

  if (minimumNoticeTime < _dates.ONE_DAY) {
    return (0, _Immutable.List)();
  }
  var numberOfDays = Math.floor(minimumNoticeTime / _dates.ONE_DAY);
  var listOfDays = (0, _utils.getListOfDays)(_I18n2.default.moment((0, _utils2.getTimeAtLoad)()), numberOfDays);
  return listOfDays.map(function (timestamp) {
    return _I18n2.default.moment(timestamp).format('YYYY-MM-DD');
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/TroubleshootingSelectors.js
// module id = 137
// module chunks = 0